import { CompensationSource, ContractStatus } from '@omnipresentgroup/types';

export const CONTRACT_STATUS_WHITELIST = new Set([
  ContractStatus.DRAFT,
  ContractStatus.PENDING_REVIEW,
  ContractStatus.REVIEW_DONE,
  ContractStatus.ARCHIVED,
]);

export const COMPENSATION_SOURCE_PARAM = 'source';

export const COMPENSATION_SOURCE_LABELS: Map<CompensationSource, string> =
  new Map([
    [CompensationSource.CONTRACTUAL, 'Contractual'],
    [CompensationSource.MONTH_ON_MONTH, 'Supplemental'],
  ]);
